import provideDataHook from '~/helpers/provideDataHook';
import {
  CarBrandAndCategory,
  getDataHook
} from '~/App/views/CarTreeAndCategory/CarBrandAndCategory';

export default provideDataHook(
  'TransportAndMachineryCategory',
  getDataHook({ mainCategory: 'transport_and_machinery' })
)(CarBrandAndCategory);
